import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IPhoneNoInputProps,
  PhoneNoInput,
} from "src/shared/forms/inputs/PhoneNoInput";
import { NORTH_AMERICAN_PHONE_REGEX } from "src/shared/forms/inputs/phoneNoValidationRegex";

export interface IContactMobileNoInputProps extends IPhoneNoInputProps {}

export const ContactMobileNoInput = ({
  label = <FormattedMessage id="contacts.mobile_no" />,
  ...rest
}: IContactMobileNoInputProps) => (
  <PhoneNoInput
    {...rest}
    label={label}
    isRequired={false}
    maxLength={32}
    phoneRegex={NORTH_AMERICAN_PHONE_REGEX}
  />
);
